<div>
  <i class="tio-users_switch" style="font-size: 64px; opacity: 0.3"></i>
  <h4 class="mb-2 mt-4" style="color: #000">Batch Assign Jobs</h4>
  <p class="mb-4">Follow our guides on how to batch assign jobs.</p>
  <a href="https://clienthub.reamaze.com/kb/manage-templates" target="_blank" rel="noreferrer noopener"
    class="btn btn-primary">Learn more</a>
</div>